import type { SlotType } from "./types";

export interface SlotTypeInput {
  id: string;
  label: string;
  summary: string;
  instructions: string;
  description?: string;
}

const KEBAB = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

function fail(id: string, what: string, fix: string): never {
  throw new Error(`Invalid slot type "${id}": ${what}. ${fix}`);
}

export function defineSlotType(input: SlotTypeInput): SlotType {
  const { id } = input;
  if (!id || !KEBAB.test(id)) {
    fail(id || "(missing)", "id must be non-empty kebab-case", 'Use lowercase words joined by "-", e.g. "carry".');
  }
  if (!input.label?.trim()) fail(id, "label is required", 'Add a human display name, e.g. "Carry".');
  if (!input.summary?.trim()) fail(id, "summary is required", "Add a one-line summary of what this slot type is for.");
  if (!input.instructions?.trim()) fail(id, "instructions is required", "Write the generation brief an agent reads when creating content for this slot.");

  return {
    id,
    label: input.label.trim(),
    summary: input.summary.trim(),
    instructions: input.instructions.trim(),
    description: input.description?.trim(),
  };
}
